export const HEADER_ARTIST_LISTING_COUNT = 3;

export const CONTACT_POPUP = "contact-popup";
export const EMAIL_PREFERENCES = "email-preferences";
export const MY_ACCOUNT = "my-account";
export const LINK_ANOTHER_ARTIST = "link-another-artist";

// we need to open pop up before 30 sec,therefore subtracting 31 sec
export const TIMEOUT = 31;
